/* NOMI popup gate.
   Lives in an asset, not inline in the section, because the theme importer
   parses inline <script> as HTML: a bare "<" followed by a letter (i<n) or a
   Liquid tag reads as an opening tag, the parser never finds </script>, the
   whole section fails validation and Shopify SILENTLY SKIPS THE FILE on import.
   That is what left the popup dead and printed a Liquid error on every page.
   Keep this file as an asset. Config comes in on data- attributes. */
(function () {
  var el = document.getElementById('nomi-popup');
  if (!el) return;

  var cfg = el.dataset || {};
  var FREQ = cfg.freq || 'always';
  var DELAY = parseInt(cfg.delay, 10);
  if (isNaN(DELAY)) DELAY = 8000;
  var EXIT = cfg.exit !== 'false';
  var DAYS = parseInt(cfg.days, 10);
  if (isNaN(DAYS)) DAYS = 30;
  var EXCLUDE = (cfg.exclude || '').split(',');

  var SEEN = 'nomi_popup_seen', DONE = 'nomi_popup_signed', SESS = 'nomi_popup_session';

  function read(store, k) {
    try { return (store === 'l' ? localStorage : sessionStorage).getItem(k); }
    catch (e) { return null; }
  }
  function write(store, k, v) {
    try { (store === 'l' ? localStorage : sessionStorage).setItem(k, v); } catch (e) {}
  }

  function signedUp() { return !!read('l', DONE); }
  function seenRecently() {
    var t = read('l', SEEN);
    if (!t) return false;
    var age = Date.now() - (+t);
    return age < DAYS * 864e5;
  }
  function markSeen() { write('l', SEEN, String(Date.now())); write('s', SESS, '1'); }
  function markSigned() { write('l', DONE, '1'); }

  var priorFocus, priorOverflow;
  function close() {
    if(el.style.display === 'none') return;
    el.style.display = 'none';
    document.documentElement.style.overflow = priorOverflow || '';
    if(priorFocus && priorFocus.focus) priorFocus.focus();
    markSeen();
  }
  function open() {
    if (document.querySelector('.nomi-drawer[data-open]')) { setTimeout(open, 4000); return; }
    priorFocus=document.activeElement; priorOverflow=document.documentElement.style.overflow;
    /* v23.68: never stack on the sample nudge */
    var nudge = document.getElementById('nomi-sample-nudge');
    if (nudge) { nudge.classList.remove('nsn--in'); nudge.hidden = true; }
    el.style.display = 'block';
    el.querySelector('[data-nomi-popup-close]').focus();
    document.documentElement.style.overflow = 'hidden';
  }

  /* v20.23: copy button on the discount success screen. */
  var copyBtn = el.querySelector('[data-nomi-popup-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var box = el.querySelector('[data-nomi-popup-code]'), code = box ? box.getAttribute('data-nomi-popup-code') : '';
    function done() { copyBtn.textContent = 'Copied'; copyBtn.classList.add('is-done'); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else { var r = document.createRange(); r.selectNodeContents(box.querySelector('span')); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); try { document.execCommand('copy'); } catch (e) {} done(); }
  });

  var closers = el.querySelectorAll('[data-nomi-popup-close]');
  for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', close);

  var form = el.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      /* Signed-up state is written only when Shopify confirms the post
         (see the data-nomi-popup-success check below), so a failed submit
         never suppresses the popup for 30 days. */
      var tags = form.querySelector('input[name="contact[tags]"]');
      var avatar = form.querySelector('input[name="nomi-avatar"]:checked');
      if (tags && avatar) tags.value = tags.value + ',avatar-' + avatar.value;
    });
  }

  document.addEventListener('keydown', function (e) { if(el.style.display==='none')return; if (e.key === 'Escape') close(); if(e.key==='Tab'){var list=Array.from(el.querySelectorAll('button,a[href],input')).filter(n=>n.offsetParent!==null);var first=list[0],last=list[list.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}} });

  /* Never cover the pages where the box is claimed, or the cart, or the popup
     would be sitting on top of its own call to action.
     v23.79: checked FIRST. Shopify marks every customer form on a page as
     "posted" after any customer form succeeds, so the sample gate's success
     used to open this popup's "You're in" screen on top of the claim step,
     and its button sent people back to an empty form. */
  var here = location.pathname.toLowerCase();
  for (var i = 0; i < EXCLUDE.length; i++) {
    var path = String(EXCLUDE[i]).trim().toLowerCase();
    if (path && here.indexOf(path) === 0) return;
  }

  if (el.querySelector('[data-nomi-popup-success]')) { markSigned(); open(); return; }
  /* A failed post reloads the page with the error inside the popup; show it. */
  if (el.querySelector('[data-nomi-popup-error]')) { open(); return; }

  /* A shared claim link opens it immediately and ignores every gate. */
  if (/[?&]claim=beef(&|$)/i.test(location.search)) { open(); return; }


  if (signedUp()) return;
  if (FREQ === 'once' && seenRecently()) return;
  if (FREQ === 'session' && read('s', SESS)) return;

  /* v20.23: fire after the delay, or once the visitor scrolls past the first
     screen, whichever comes first; on desktop also on exit intent (mouse
     leaving through the top of the window) after a short grace period. */
  var opened=false, armed=false;
  function fire(){ if(opened) return; opened=true; window.removeEventListener('scroll',onScroll); document.removeEventListener('mouseleave',onLeave); open(); }
  function onScroll(){ if(armed && window.scrollY>window.innerHeight*0.8) fire(); }
  function onLeave(e){ if(armed && e.clientY<=0 && window.innerWidth>820) fire(); }
  setTimeout(function(){ armed=true; onScroll(); }, 1500);
  setTimeout(fire, Math.max(1500, DELAY));
  window.addEventListener('scroll',onScroll,{passive:true});
  if (EXIT) document.addEventListener('mouseleave',onLeave);
})();
